// extracted by mini-css-extract-plugin
export var contentGrid = "_t-3";
export var divider = "_t-t";
export var emailInput = "_t-8";
export var emptyDescription = "_t-z";
export var emptyState = "_t-x";
export var emptyTitle = "_t-y";
export var fadeIn = "_t-10";
export var formCard = "_t-5";
export var formGroup = "_t-7";
export var helperText = "_t-9";
export var imagePlaceholder = "_t-n";
export var itemDetails = "_t-l";
export var itemImage = "_t-m";
export var itemInfo = "_t-p";
export var itemName = "_t-q";
export var itemPrice = "_t-s";
export var itemQuantity = "_t-r";
export var itemsList = "_t-j";
export var mainContent = "_t-4";
export var orderItem = "_t-k";
export var orderSummaryCard = "_t-i";
export var pageContainer = "_t-0";
export var pageHeader = "_t-1";
export var pageTitle = "_t-2";
export var paymentDescription = "_t-e";
export var paymentIcon = "_t-b";
export var paymentInfo = "_t-a";
export var paymentMethods = "_t-f";
export var paymentText = "_t-d";
export var placeholderText = "_t-o";
export var sectionTitle = "_t-6";
export var sidebarContent = "_t-h";
export var stripeIcon = "_t-c";
export var submitButton = "_t-g";
export var totalAmount = "_t-w";
export var totalLabel = "_t-v";
export var totalRow = "_t-u";